import { DsmProductImage } from './dsm-deal-options.models';

export interface DsmPackageCreatePayload {
  name: string;
  modelId: string;
  elevationId: string;
  discountPercentage: number | null;
}

export interface DsmPackageUpdatePayload {
  name: string;
  isActive: boolean;
  discountPercentage?: number | null;
}

export interface DsmPackageAddProductsPayload {
  modelElevationProductsIds: string[];
}

export interface DsmPackageImportFromPackagePayload {
  copyFromPackageId: string;
  copyToPackageId: string;
}

export interface DsmPackageProjectInfo {
  id: string;
  code?: string | null;
  name?: string | null;
  productListId?: string | null;
}

export interface DsmPackageListItem {
  id: string;
  name: string;
  isActive?: boolean;
  project?: DsmPackageProjectInfo;
  modelId?: string;
  modelName?: string;
  elevationId?: string;
  elevationCode?: string;
  elevationDescription?: string;
  itemCount?: number;
  totalPrice?: number;
  discountPercentage?: number | null;
  discountAmount?: number;
  totalPriceAfterDiscount?: number;
}

export interface DsmPackageProductCategory {
  id?: string;
  description?: string;
  code?: string;
}

export interface DsmPackageProductSubcategory {
  id?: string;
  description?: string;
  code?: string;
  category?: DsmPackageProductCategory | null;
}

export interface DsmPackageProductUofm {
  id?: string;
  code?: string;
  description?: string;
}

export interface DsmPackageProductClass {
  id?: string;
  name?: string;
}

export interface DsmPackageProductType {
  id?: string;
  name?: string;
}

export interface DsmPackageProductInfo {
  id?: string;
  code?: string;
  description?: string;
  salesDescription?: string;
  selectionRequired?: boolean;
  images?: DsmProductImage[];
  subcategory?: DsmPackageProductSubcategory | null;
  productClass?: DsmPackageProductClass | null;
  uofm?: DsmPackageProductUofm | null;
}

export interface DsmPackageProductSummary {
  id: string;
  modelElevationProductsId: string;
  unitPrice: number;
  quantity: number;
  /** How many of this product the package includes (min 1). Distinct from product quantity. */
  count: number;
  retailCredit?: number;
  amount?: number;
  discountAmount?: number;
  netAmount?: number;
  product?: DsmPackageProductInfo | null;
  productType?: DsmPackageProductType | null;
  uofm?: DsmPackageProductUofm | null;
}

export interface DsmPackageDetail {
  id: string;
  name: string;
  isActive?: boolean;
  project?: DsmPackageProjectInfo;
  modelId?: string;
  modelName?: string;
  elevationId?: string;
  elevationCode?: string;
  elevationDescription?: string;
  itemCount?: number;
  totalPrice?: number;
  products: DsmPackageProductSummary[];
  createdAt?: string;
  lastModified?: string | null;
  discountPercentage?: number | null;
  discountAmount?: number;
  totalPriceAfterDiscount?: number;
}

export interface DsmPackageFilters {
  projectId?: string | null;
  modelId?: string | null;
  elevationId?: string | null;
  isActive?: boolean | null;
}

export interface DsmPackageProjectModelElevationOption {
  modelId: string;
  modelName: string;
  elevationId: string;
  elevationCode: string;
}

export interface DsmPackageCopyTarget {
  modelId: string;
  elevationId: string;
}

export interface DsmPackageCopyPreviewProduct {
  productId: string;
  sourceModelElevationProductsId: string;
  code?: string | null;
  description?: string | null;
  isAvailable: boolean;
  reason?: string | null;
}

export interface DsmPackageCopyPreviewTarget {
  modelId: string;
  elevationId: string;
  canCreate: boolean;
  reason?: string | null;
  availableProductCount?: number;
  products?: DsmPackageCopyPreviewProduct[];
}

export interface DsmPackageCopyPreviewResult {
  packageId: string;
  packageName: string;
  targets: DsmPackageCopyPreviewTarget[];
}

export const enum DsmPackageCopyStatus {
  Created = 'Created',
  Refused = 'Refused'
}

export interface DsmPackageCopyTargetResult {
  modelId: string;
  elevationId: string;
  status: DsmPackageCopyStatus;
  reason?: string | null;
  packageId?: string | null;
  copiedProductCount?: number;
}
